import React, { Children, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'grab-ui';
import I18n from 'i18n-js';
import styles from './collapse.less';
import stepSvg from '../../public/images/step.svg';
import expandSvg from '../../public/images/expand.svg';
import shrinkSvg from '../../public/images/shrink.svg';

const CollapseToggle = ({ isActive, onClick }) => (
  <Button className={styles.toggleButton} onClick={onClick} size="small">
    <img src={stepSvg} alt="step indicator" />

    <p>
      {isActive
        ? I18n.t('deliveryDetails.toggleIcon.shrink')
        : I18n.t('deliveryDetails.toggleIcon.expand')}
    </p>

    {isActive ? (
      <img src={shrinkSvg} alt="shrink" />
    ) : (
      <img src={expandSvg} alt="expand" />
    )}
  </Button>
);

CollapseToggle.propTypes = {
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

// TODO:: Add slide down animation - DELVEXPS-24818
const Collapse = ({ hideThreshold, children }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const childrenCount = Children.count(children);

  const toggleExpand = useCallback(
    () => {
      setIsExpanded(!isExpanded);
    },
    [isExpanded],
  );

  if (childrenCount < hideThreshold)
    return <div className={styles.panel}>{children}</div>;

  return (
    <div>
      <CollapseToggle isActive={isExpanded} onClick={toggleExpand} />

      <div className={styles.panel}>{isExpanded ? children : null}</div>
    </div>
  );
};

Collapse.propTypes = {
  hideThreshold: PropTypes.number,
  children: PropTypes.node,
};

Collapse.defaultProps = {
  hideThreshold: 4,
  children: null,
};

export default Collapse;
